import React from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import {
 
  geyser1,
  geyser2,
  geyser3,
  geyser4,
  geyser5,
  geyser6,
  geyser7,
  geyser8,
  geyser9,
  geyser10,
  geyser11,
  geyser12,
 


} from "../assets/images/index";

const GeyserPrice = () => {
  const products = [
   
      {
        _id:"100001",
        img:geyser1,
        productName:"CANON ELECTRIC STORAGE GEYSER 30 LITER Model EWT 3021",
        price:"25500",
        color:"CANON",
        badge:true,
        des:"The Canon EWT 3021 is a 30-liter electric storage geyser that provides a reliable and efficient solution for your hot water needs. It’s designed to provide a steady supply of hot water for your home, ensuring you never run out of hot water when you need it."
      },
      {
        _id:"100002",
        img:geyser2,
        productName:"CANON INSTANT GAS GEYSER Model IGWH-16DD",
        price:"19800",
        color:"CANON",
        badge:true,
        des:"The INS-16DD PLUS NG is an instant water geyser from Canon. It’s designed with a silver paint cover, grey bottom cover, and an ultra-low water-pressure start system. It also features flame out protection and battery auto ignition for safety and efficiency."
      },
      {
        _id:"100003",
        img:geyser3,
        productName:"CANON ELECTRIC STORAGE GEYSER 60 LITER Model EWT-60 ",
        price:"30000",
        color:"CANON",
        badge:true,
        des:"The Canon EWT-60 is a 60-liter Electric Storage Geyser that operates on 220-240 volts and draws 2000 watts of power. It provides hot water quickly and maintains the temperature throughout the day. It also features an adjustable thermostat for temperature control."
      },
      {
        _id:"100004",
        img:geyser4,
        productName:"MAX ELECTRIC STORAGE GEYSER 60 LITER Model 60L",
        price:"26700",
        color:"Geyser",
        badge:true,
        des:" The MAX ELECTRIC STORAGE GEYSER 60 LITER Model 60L is a robust and efficient water heater with a 60-liter capacity. It’s designed for efficient temperature control and comes with a safety valve. The product is built to last, offering a 1-year warranty."
      },
      {
        _id:"100005",
        img:geyser5,
        productName:"ARISTON ELECTRIC STORAGE GEYSER 50 LITRE Model 50L- BLU R V",
        price:"80700",
        color:"ARISTON",
        badge:true,
        des:"The ARISTON 50L- BLU R V is a 50-liter electric storage water heater designed in Italy. It features a modern shape and high-quality materials, with sleek aesthetic finishes that make it an interior design item."
      },
      {
        _id:"100006",
        img:geyser6,
        productName:"SUPER ASIA ELECTRIC GEYSER 30 LITER Model MEH-30 ",
        price:"42000",
        color:"SUPER ASIA",
        badge:true,
        des:" The SUPER ASIA MEH-30 is a 30-liter electric water heater that provides instant and continuous hot water. It’s designed with an efficient heating system and precision thermostat control, ensuring energy efficiency and safety."
      },
      {
        _id:"100007",
        img:geyser7,
        productName:"CANON INSTANT GAS GEYSER 10 LITER Model 20DD LPG",
        price:"33300",
        color:"CANON",
        badge:true,
        des:"The CANON INSTANT GEYSER 10 LITER Model 20DD LPG is a wall-mounted gas water heater that provides instant, continuous, and abundant hot water. It’s designed with modern technology and optimal fuel consumption, ensuring energy efficiency and safety."
      },
      {
        _id:"100008",
        img:geyser8,
        productName:"SUPER ASIA INSTANT GAS GEYSER 6 LITRE Model GH-106 DI LPG ",
        price:"18000",
        color:"SUPER ASIA",
        badge:true,
        des:" The GH-106 DI LPG is a 6-liter instant gas geyser from Super Asia. It’s designed for quick heating, providing hot water as soon as you need it. The product is built with safety and efficiency in mind, ensuring a reliable and comfortable experience."
      },
      {
        _id:"100009",
        img:geyser9,
        productName:"SUPER ASIA ELECTRIC STORAGE GEYSER 10 LITER Model SEH-10",
        price:"23400",
        color:"SUPER ASIA",
        badge:true,
        des:"The Super Asia SEH-10 is a 10-liter electric water heater that provides a reliable and efficient solution for your hot water needs. It’s designed with an enamel coated tank and heating element for durability, and features a range of safety protections to ensure safe operation."
      },
      {
        _id:"1000010",
        img:geyser10,
        productName:"SUPER ASIA ELECTRIC & GAS GEYSER 30 GALLON Model GEH735-AI ",
        price:"62400",
        color:"SUPER ASIA",
        badge:true,
        des:" The GEH735-AI is a versatile 35-gallon electric and gas geyser from Super Asia. It offers dual functionality, allowing you to choose between gas and electric operation to suit your needs. With its large capacity, it provides plenty of hot water for daily use. The GEH735-AI combines advanced technology with reliable performance, ensuring quick and efficient heating."
      },
      {
        _id:"1000011",
        img:geyser11,
        productName:"CANON FAST ELECTRIC GEYSER 30 LITER Model EWH-30 LCM",
        price:"31500",
        color:"CANON FAST",
        badge:true,
        des:"The Canon Fast Electric Geyser 30 Liter EWH-30LCM offers rapid heating and a spacious 30-liter capacity, making it ideal for large households. Its advanced safety features and energy-efficient operation ensure reliable and safe hot water supply."
      },
      {
        _id:"1000012",
        img:geyser12,
        productName:"ARISTON ELECTRIC STORAGE GEYSER 80 LITRE Model 80L BLU R V ",
        price:"102300",
        color:"ARISTON",
        badge:true,
        des:" The Ariston 80L Blur V is a high-efficiency electric storage geyser designed to provide reliable hot water. It features a sleek, modern design with advanced safety and insulation features, making it a great addition to any home."
      },
      {
        _id:"100001",
        img:geyser1,
        productName:"CANON ELECTRIC STORAGE GEYSER 30 LITER Model EWT 3021 ",
        price:"25500",
        color:"CANON",
        badge:true,
        des:"The Canon EWT 3021 is a 30-liter electric storage geyser that provides a reliable and efficient solution for your hot water needs. It’s designed to provide a steady supply of hot water for your home, ensuring you never run out of hot water when you need it."
      },
      {
        _id:"100002",
        img:geyser2,
        productName:"CANON INSTANT GAS GEYSER Model IGWH-16DD",
        price:"19800",
        color:"CANON",
        badge:true,
        des:"The INS-16DD PLUS NG is an instant water geyser from Canon. It’s designed with a silver paint cover, grey bottom cover, and an ultra-low water-pressure start system. It also features flame out protection and battery auto ignition for safety and efficiency."
      },
      {
        _id:"100003",
        img:geyser3,
        productName:"CANON ELECTRIC STORAGE GEYSER 60 LITER Model EWT-60",
        price:"30000",
        color:"CANON",
        badge:true,
        des:"The Canon EWT-60 is a 60-liter Electric Storage Geyser that operates on 220-240 volts and draws 2000 watts of power. It provides hot water quickly and maintains the temperature throughout the day. It also features an adjustable thermostat for temperature control."
      },
      {
        _id:"100004",
        img:geyser4,
        productName:"MAX ELECTRIC STORAGE GEYSER 60 LITER Model 60L",
        price:"26700",
        color:"Geyser",
        badge:true,
        des:" The MAX ELECTRIC STORAGE GEYSER 60 LITER Model 60L is a robust and efficient water heater with a 60-liter capacity. It’s designed for efficient temperature control and comes with a safety valve. The product is built to last, offering a 1-year warranty."
      },

     
    
  ];

  const downloadPDF = () => {
    const input = document.getElementById("price-list"); 
    const pdf = new jsPDF("p", "mm", "a4");
    const pageHeight = pdf.internal.pageSize.height; 
    const pageWidth = pdf.internal.pageSize.width;
  
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const imgWidth = pageWidth; 
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
  
      let yPosition = 0;
  
      while (yPosition < imgHeight) {
        pdf.addImage(imgData, "PNG", 0, -yPosition, imgWidth, imgHeight);
        yPosition += pageHeight; 
  
        if (yPosition < imgHeight) {
          pdf.addPage(); 
        }
      }
  
      pdf.save("price-list.pdf");
    });
  };
  return (
    <div className="max-w-container mx-auto px-4">
      <h1 className="text-2xl font-bold mb-5">Geyser Price List</h1>
      <button
        onClick={downloadPDF}
        className="bg-dark text-white px-4 py-2 mb-5 rounded"
      >
        Download PDF
      </button>
      <div id="price-list" className="space-y-6">
        {products.map((product) => (
          <div
            key={product._id}
            className="flex items-start border rounded shadow p-5"
          >
            <img
              src={product.img}
              alt={product.productName}
              className="w-36 h-36 object-contain mr-5"
            />
            <div>
              <h2 className="text-xl font-semibold">{product.productName}</h2>
              <p className="text-gray-600 mt-2">{product.des}</p>
              <span className="text-lg font-bold mt-2 block">
                Rs.{product.price}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GeyserPrice;
